import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const portal = axios.create({ baseURL: API_BASE });

portal.interceptors.request.use((config) => {
  const token = localStorage.getItem("venka_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authLogin = (email, password) =>
  portal.post("/auth/login", { email, password }).then((r) => r.data);
export const authMe = () => portal.get("/auth/me").then((r) => r.data);

export const getStats = () => portal.get("/portal/stats").then((r) => r.data);
export const getProcesses = (params = {}) =>
  portal.get("/portal/processes", { params }).then((r) => r.data);
export const getProcessDetail = (id) =>
  portal.get(`/portal/processes/${id}`).then((r) => r.data);
export const changeStatus = (id, new_status, comment) =>
  portal.patch(`/portal/processes/${id}/status`, { new_status, comment }).then((r) => r.data);
export const getPortalUsers = (role) =>
  portal.get("/portal/users", { params: role ? { role } : {} }).then((r) => r.data);
export const createUser = (payload) =>
  portal.post("/auth/users", payload).then((r) => r.data);
export const addDocument = (process_id, title, kind = "submitted") =>
  portal.post("/portal/documents", { process_id, title, kind }).then((r) => r.data);
export const uploadProducedDocument = (documentId, file) => {
  const form = new FormData();
  form.append("file", file);
  return portal
    .post(`/portal/documents/${documentId}/upload`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const deleteDocument = (documentId) =>
  portal.delete(`/portal/documents/${documentId}`).then((r) => r.data);
export const updateDocStatus = (id, status, rejection_reason) =>
  portal
    .patch(`/portal/documents/${id}/status`, { status, rejection_reason })
    .then((r) => r.data);
export const bulkPendingReminders = () =>
  portal.post("/portal/reminders/pending-docs").then((r) => r.data);
export const getPortalUnread = () =>
  portal.get("/portal/unread").then((r) => r.data);
export const markPortalRead = (id) =>
  portal.post(`/portal/processes/${id}/messages/read`).then((r) => r.data);
export const getAccountUnread = () =>
  portal.get("/account/unread").then((r) => r.data);
export const markAccountRead = (id) =>
  portal.post(`/account/processes/${id}/messages/read`).then((r) => r.data);
export const sendProcessMessageFile = (id, body, file) => {
  const form = new FormData();
  form.append("body", body || "");
  if (file) form.append("file", file);
  return portal
    .post(`/portal/processes/${id}/messages/upload`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const sendMyMessageFile = (id, body, file) => {
  const form = new FormData();
  form.append("body", body || "");
  if (file) form.append("file", file);
  return portal
    .post(`/account/processes/${id}/messages/upload`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

// ----- Customer (account) portal -----
export const getMyProcesses = () =>
  portal.get("/account/processes").then((r) => r.data);
export const getMyProcessDetail = (id) =>
  portal.get(`/account/processes/${id}`).then((r) => r.data);

// ----- In-app messaging -----
export const getProcessMessages = (id) =>
  portal.get(`/portal/processes/${id}/messages`).then((r) => r.data);
export const sendProcessMessage = (id, body) =>
  portal.post(`/portal/processes/${id}/messages`, { body }).then((r) => r.data);
export const getMyMessages = (id) =>
  portal.get(`/account/processes/${id}/messages`).then((r) => r.data);
export const sendMyMessage = (id, body) =>
  portal.post(`/account/processes/${id}/messages`, { body }).then((r) => r.data);
export const uploadDocument = (documentId, file) => {
  const form = new FormData();
  form.append("file", file);
  return portal
    .post(`/account/documents/${documentId}/upload`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

// ----- Notifications outbox (staff) -----
export const getNotifications = () =>
  portal.get("/portal/notifications").then((r) => r.data);
export const getNotificationDetail = (id) =>
  portal.get(`/portal/notifications/${id}`).then((r) => r.data);

// ----- Country-specific case (Canada) -----
export const getCanadaCase = (id) =>
  portal.get(`/applications/${id}/case`).then((r) => r.data);
export const getCaseSecure = (id) =>
  portal.get(`/applications/${id}/secure`).then((r) => r.data);

// ----- Tasks (staff work queue) -----
export const getTasks = () => portal.get("/portal/tasks").then((r) => r.data);
export const completeTask = (id) =>
  portal.patch(`/portal/tasks/${id}`).then((r) => r.data);
export const assignProcess = (id, agentId) =>
  portal.patch(`/portal/processes/${id}/assign`, null, { params: { agent_id: agentId } }).then((r) => r.data);

// ----- Application form export (PDF / Excel) -----
export const downloadCaseFile = (id, kind) =>
  portal.get(`/applications/${id}/${kind}`, { responseType: "blob" }).then((r) => r.data);

// ----- Saved filter views -----
export const getSavedViews = () => portal.get("/portal/views").then((r) => r.data);
export const createSavedView = (name, filters) =>
  portal.post("/portal/views", { name, filters }).then((r) => r.data);
export const deleteSavedView = (id) =>
  portal.delete(`/portal/views/${id}`).then((r) => r.data);

export default portal;

// Shared authenticated client for newer modules (alerts, billing, AI agents).
export const portalClient = portal;
export const getAlerts = (limit = 30) => portal.get("/portal/alerts", { params: { limit } }).then((r) => r.data);
export const markAlertsRead = (body = {}) => portal.post("/portal/alerts/read", body).then((r) => r.data);
